/* eslint-disable no-restricted-imports */
import * as base from "libphonenumber-js";

export * from "libphonenumber-js";

const defaultCountries: base.CountryCode[] = ["CA", "US"];

export const isValidPhoneNumber: typeof base.isValidPhoneNumber = (
    text,
    defaultCountry
) => {
    if (!defaultCountry) {
        return defaultCountries.some((country) =>
            base.isValidPhoneNumber(text, country)
        );
    }

    return base.isValidPhoneNumber(text, defaultCountry);
};

/**
 * @deprecated `parsePhoneNumber()` named export has been renamed to `parsePhoneNumberWithError()`
 */
export const parsePhoneNumber: typeof base.parsePhoneNumber = (
    text,
    defaultCountry
) => parsePhoneNumberWithError(text, defaultCountry);

/**
 * Parse does NOT equal valid. Use `isValidPhoneNumber()` or `parsePhoneNumberWithError().isValid()` to check if the phone number is valid.
 */
export const parsePhoneNumberWithError: typeof base.parsePhoneNumberWithError =
    (text, defaultCountry) => {
        if (!defaultCountry) {
            const mapped = defaultCountries.map((country) => {
                try {
                    return {
                        success: true,
                        number: base.parsePhoneNumberWithError(text, country),
                    } as const;
                } catch (e) {
                    return { success: false, error: e } as const;
                }
            });

            const resp = (
                mapped.find(
                    (number) => number.success && number.number.isValid()
                ) || mapped.find((number) => number.success)
            )?.number;

            if (!resp) {
                throw (
                    mapped.find((number) => !number.success)?.error ||
                    new Error("No valid phone number found.")
                );
            }

            return resp;
        }

        return base.parsePhoneNumberWithError(text, defaultCountry);
    };

export const isPossiblePhoneNumber: typeof base.isPossiblePhoneNumber = (
    text,
    defaultCountry
) => {
    if (!defaultCountry) {
        return defaultCountries.some((country) =>
            base.isPossiblePhoneNumber(text, country)
        );
    }

    return base.isPossiblePhoneNumber(text, defaultCountry);
};

export const validatePhoneNumberLength: typeof base.validatePhoneNumberLength =
    (text, defaultCountry) => {
        if (!defaultCountry) {
            const mapped = defaultCountries.map((country) => {
                return base.validatePhoneNumberLength(text, country);
            });

            return mapped.find((result) => result);
        }

        return base.validatePhoneNumberLength(text, defaultCountry);
    };
